<template>
  <div class="about">
    <div class="about-container">
      <div class="about-content">
        <h2 class="about-title">
          <router-link class="title-link hover:opacity-80 transition-opacity" :to="{ name: $t('aboutUsRouteName') }">
            {{ $t("aboutUs") }}
          </router-link>
        </h2>
        <div class="about-devided-section">
          <p class="about-devided-text" v-html="$t('highlightedServicesShortText')"></p>
          <router-link :to="{ name: $t('aboutUsRouteName') }" tag="a" class="about-devided-button"> {{ $t("more")
          }}</router-link>
        </div>
      </div>
      <div class="about-image">
        <img :src="require(`@/assets/Profesionalnost.jpg`)" :alt="$t('aboutUsList1')" class="card-image" loading="lazy">
      </div>
    </div>
  </div>
</template>


<script>

export default {
  data() {
    return {
    }
  },
}
</script>


<style scoped>
.about {
  /* background:  var(--secondary-color); */
  padding: 20px 7%;
  /* min-height: 500px; */
  display: flex;
  align-items: stretch;
  width: 100%;
}

.about-container {
  width: 100%;
  display: flex;
  gap: 10px;
  align-items: stretch;
}

.about-content {
  width: 65%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.about-title {
  color: var(--main-color);
  font-size: 30px;
  margin-bottom: 15px;
  font-weight: 600;
  /* letter-spacing: -0.025em; */
  cursor: pointer;
  padding-left: 3px;
}

.about-title a,
.about-title router-link {
  color: var(--main-color);
  text-decoration: none;
}

.highlight {
  color: var(--main-color);
  position: relative;
  display: inline-block;
}

.highlight::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: var(--main-color);
  transform: scaleX(0);
  transform-origin: right;
  transition: transform 0.3s ease;
}

.about-content:hover .highlight::after {
  transform: scaleX(1);
  transform-origin: left;
}

.about-devided-section {
  /* background: var(--light-color); */
  background: var(--secondary-color);
  backdrop-filter: blur(8px);
  border-radius: 1rem;
  padding: 2rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  width: 95%;
}

.about-devided-text {
  font-size: 20px;
  line-height: 1.2;
  font-weight: 500;
  color: #465481;
  margin-bottom: 2rem;
}

.about-devided-button {
  display: inline-block;
  /* background-color: #F68600; */
  background-color: transparent;
  color: var(--main-color);
  border: 1px solid var(--main-color);
  padding: 10px;
  border-radius: 0.5rem;
  /* font-size: 1.125rem; */
  font-size: 18px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
  text-align: center;
  width: 35%;
  min-width: 150px;
  max-width: 250px;
}

.about-devided-button:hover {
  background-color: var(--main-color);
  color: #fff;
  transition: color 0.3s ease, background-color 0.3s ease;
}

.about-devided-section:hover a {
  text-decoration: underline;
  text-decoration-color: #fff;
}

.about-image {
  width: 35%;
  height: 230px;
  position: relative;
  border-radius: 1rem;
  overflow: hidden;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.about-image img {
  width: 100%;
  height: 100%;
  /* object-fit: cover; */
  object-fit: fill;
  transition: transform 0.6s ease;
}

.about-image:hover img {
  transform: scale(1.02);
}


@media (max-width: 1200px) {
  .about-title {
    font-size: 30px;
  }

  .about-devided-text {
    /* font-size: 1.125rem; */
    font-size: 18px;

  }

  .about-button {
    width: 50%;
  }


}

@media (max-width: 992px) {

  .about-devided-section {
    width: 100%;
  }

  .about-container {
    flex-direction: column;
    gap: 2rem;
  }

  .about-content,
  .about-image {
    width: 100%;
  }

  .about-content {
    justify-content: start;
    height: auto;
  }

  .about-title,
  .about-section {
    width: 100%;
  }

  .about-button {
    width: 40%;
  }

  .about-image {
    height: 350px;
  }

  .about-image img {
    object-fit: fill;
  }
}

@media (max-width: 768px) {
  .about {
    padding: 4rem 7%;
  }

  .about-title {
    font-size: 1.75rem;
  }

  .about-section {
    padding: 1.5rem;
  }

  .about-text {
    font-size: 18px;
  }

  .about-button {
    width: 50%;
  }

  .about-image {
    height: 300px;
    max-height: 300px;
  }

  .about-devided-button {
    padding: 5px;
  }
}

@media (max-width: 480px) {
  .about {
    padding: 3rem 7%;
  }

  .about-title {
    font-size: 1.5rem;
  }

  .about-image {
    height: 250px;
  }

  .about-button {
    width: 100%;
  }

  .about-devided-text {
    font-size: 18px;

  }
}
</style>